// extracted by mini-css-extract-plugin
module.exports = {"checkboxIcon":"_2uGY5Z8AMj_vN0fsfWq7XV","checkboxText":"skZlur9RrIzfJ59KWIr_v"};